import QuantityProduct from './QuantityProduct'

class EdgePhotoProduct extends QuantityProduct {}

export default EdgePhotoProduct
